const SHAPES = {
  freehand: 'freehand',
  line: 'line',
  circle: 'circle'
};

export default SHAPES;
